import { RemoteRolesService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const rolesService = new RemoteRolesService(httpClient)
